<template>
  <section>
    <div
      v-if="store.getters?.getRelatos.length > 0"
      class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
    >
      <div
        class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white sticky left-0"
      >
        <DropDownOptions
          class="uppercase"
          v-model="selectedFilter"
          :label="'Documentos'"
          :options="[
            'Todos',
            ...filters
          ]"
        />

        <SearchInput v-model="searchTerm" />
      </div>

      <section class="max-h-[51vh] md:max-h-[53vh] lg:max-h-[62vh]">
        <DataTable :data="filteredData" @delete="deleteRelato">
          <template #head>
            <th scope="col" class="px-6 py-3">Relato</th>
            <th scope="col" class="px-6 py-3">Comite Responsável</th>
            <th scope="col" class="px-6 py-3">Classificação</th>
            <th scope="col" class="px-6 py-3">Status</th>
            <th scope="col" class="px-6 py-3">Empresa Relatada</th>
            <th scope="col" class="px-4 py-3 text-center">#</th>
          </template>
        </DataTable>
      </section>
    </div>

    <NoDataAnim v-else :label="'Não há relatos'" />

    <!-- drawer -->
    <Transition mode="out-in">
      <BaseModal
        :isOpen="isModalOpen"
        @update:isOpen="closeModal"
        :key="modalData"
      >
        <!-- drawer employee -->
        <div
          id="drawer-right-example"
          class="fixed top-0 right-0 z-40 h-screen overflow-y-auto transition-transform bg-white w-80 overflow-x-hidden"
          :class="{
            'translate-x-0': isModalOpen,
            'translate-x-full': !isModalOpen,
          }"
          tabindex="-1"
          aria-labelledby="drawer-right-label"
        >
          <section>
            <main class="flex flex-col h-screen">
              <!-- header -->
              <div class="bg-gray-100 p-2 pt-0 pb-0">
                <!-- TItulo -->
                <h5
                  id="drawer-right-label"
                  class="inline-flex items-center mb-4 text-lg font-semibold text-gray-600 dark:text-gray-600 mt-3 mr-6"
                >
                  <PhInfo class="w-6 h-6 me-2.5 text-gray-700" />
                  Detalhes do relato
                </h5>

                <!-- close button -->
                <button
                  type="button"
                  aria-controls="drawer-right-example"
                  class="text-gray-400 bg-transparent hover:text-gray-700 text-sm w-8 h-8 absolute -end-2 mt-3 mr-2"
                  @click="closeModal"
                >
                  <component :is="PhX" class="w-7 h-6"></component>
                </button>
              </div>

              <!-- content -->
              <section class="p-2">
                <div class="pt-0 pb-0 mb-4">
                  <div class="w-full">
                    <section
                      class="text-lg w-full p-5 pt-0 pb-1 px-1 font-semibold  text-left text-gray-900 bg-white dark:text-gray-600 uppercase"
                    >
                      Relator: <small>{{ modalContent.name }}</small>
                      <p
                        class="text-sm font-normal text-gray-500 dark:text-gray-400 lowercase -mt-0.5"
                      >
                        Dados da empresa que abriu o relato
                      </p>
                    </section>
                  </div>

                  <div
                    class="flex text-sm pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">
                        Nº do relato </label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ "RCD-" + modalContent.id }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="font-medium text-gray-400 text-xs"
                        >Status</label
                      ><br />
                      <label
                        class="text-gray-700 text-sm uppercase"
                        :class="[
                          modalContent?.status === 'crítico'
                            ? 'text-red-500 font-bold'
                            : '',
                          modalContent?.status === 'controlado'
                            ? 'text-yellow-500 font-bold'
                            : '',
                          modalContent?.status === 'resolvido'
                            ? 'text-green-500 font-bold'
                            : '',
                          modalContent?.status === 'cancelado'
                            ? 'text-gray-500 font-bold'
                            : '',
                        ]"
                      >
                        {{ modalContent?.status }}
                      </label>
                    </div>
                  </div>

                  <div
                    class="flex text-gray-700 pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Classificação</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent?.relatoClassi }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Comite responsável</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase font-bold">
                        {{ modalContent?.relatoCompe }}
                      </label>
                    </div>
                  </div>

                  <div
                    class="flex text-sm pt-2 w-full justify-between font-semibold pb-1"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Empresa</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{
                          JSON.parse(modalContent?.empresa).name?.length > 20
                            ? JSON.parse(modalContent?.empresa)
                                .name.slice(0, 20)
                                .concat("...")
                            : JSON.parse(modalContent?.empresa).name
                        }}
                        -
                        {{
                          modalContent?.unidade?.length > 10
                            ? modalContent?.unidade.slice(0, 10).concat("...")
                            : modalContent?.unidade
                        }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">
                        Setor de abertura </label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent.setor }}
                      </label>
                    </div>
                  </div>

                  <!-- title -->
                  <div class="w-full border-t pt-1 border-gray-400">
                    <section
                      class="text-lg w-full p-5 pt-0 pb-1 px-1 font-semibold text-left text-gray-900 bg-white dark:text-gray-600 uppercase"
                    >
                      Empresa relatada
                      <p
                        class="-mt-0.5 text-sm font-normal text-gray-500 dark:text-gray-400 lowercase"
                      >
                        Detalhes da empresa relatada e relato
                      </p>
                    </section>
                  </div>

                  <!-- empresa e unidade -->
                  <div
                    class="flex text-gray-700 pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="font-medium text-gray-400 text-xs"
                        >Empresa</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{
                          modalContent?.relatoEmpresa?.length > 10
                            ? modalContent?.relatoEmpresa
                                .slice(0, 10)
                                .concat("...")
                            : modalContent?.relatoEmpresa
                        }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Unidade</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{
                          modalContent?.relatoUnidade?.length > 10
                            ? modalContent?.relatoUnidade
                                .slice(0, 10)
                                .concat("...")
                            : modalContent?.relatoUnidade
                        }}
                      </label>
                    </div>
                  </div>

                  <!-- setor e data -->
                  <div
                    class="flex text-sm pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">
                        Setor relatado </label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent.relatoSetor }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">Data</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ formatDate(modalContent.relatoDate) }}
                      </label>
                    </div>
                  </div>

                  <!-- gravidade e frequancia -->
                  <div
                    class="flex text-sm pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Gravidade</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent?.gravity }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="font-medium text-gray-400 text-xs"
                        >Frequência</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent?.frequency }}
                      </label>
                    </div>
                  </div>

                  <!-- classificação e ação tomada -->
                  <div
                    class="flex text-gray-700 pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">
                        Classificação
                      </label>
                      <br />

                      <label class="text-gray-700 text-sm uppercase">
                        <strong>
                          <section
                            class="lowercase"
                            :class="[
                              classification == 'Risco Alto'
                                ? 'text-red-500'
                                : '',
                              classification == 'Risco Moderado/Alto'
                                ? 'text-red-400'
                                : '',
                              classification == 'Risco Substancial'
                                ? 'text-red-600'
                                : '',
                              classification == 'Risco Crítico'
                                ? 'text-red-700'
                                : '',
                            ]"
                          >
                            <span class="mt-auto flex justify-center">
                              {{ setClassification() }}
                            </span>
                            <div class="w-full flex justify-center">
                              <div v-for="item in skulls" :key="item">
                                <img :src="iconSkull" class="w-9 h-9" />
                              </div>
                            </div>
                          </section>
                        </strong>
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">
                        Ação tomada </label
                      ><br />
                      <label class="text-gray-700 text-sm lowercase">
                        {{
                          modalContent.relatoAcao.length > 40
                            ? modalContent.relatoAcao.slice(0, 40).concat("...")
                            : modalContent.relatoAcao
                        }}
                      </label>
                    </div>
                  </div>

                  <!-- relato e mitigação -->
                  <div
                    class="flex text-gray-700 pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="font-medium text-gray-400 text-xs"
                        >Relato</label
                      ><br />
                      <small class="text-gray-700 text-sm lowercase">
                        {{ modalContent.relatoDescript }}
                      </small>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Risco mitigado</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent?.relatoMiti }}
                      </label>
                    </div>
                  </div>

                </div>

              </section>

              <section class="mt-1 sticky bottom-6 shadow bord h-full">
                <div
                  class="h-12 mt-2 bg-gradient-to-t from-white to-transparent pointer-events-none z-10"
                ></div>
                <div class="rounded-3xl rounded-b-none px-3 pt-3 border border-t border-gray-400 bg-white h-full">
                  <!-- title -->
                  <div class="w-full pt-1 flex">
                    <div class="h-full flex justify-center">
                      <component class="w-10 h-10 mt-1 text-[#509f2d]" :is="PhFileArrowUp"></component>
                    </div>
                    <section
                      class="text-lg w-full p-5 pt-0 pb-1 px-1 font-semibold text-left text-gray-900 bg-white uppercase"
                    >
                      Atualizar relato
                      <p
                        class="-mt-0.5 text-sm font-normal text-gray-500 lowercase"
                      >
                        defina um novo status para esse relato
                      </p>
                    </section>
                  </div>
                  <!-- buttons -->
                  <div :key="modalContent?.status" class="grid place-items-center grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2">
                    <button
                      type="button"
                      id="status"
                      class="hover:bg-green-800 border-[#03543f] text-[#03543f] before:bg-[#03543f] focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded text-sm px-5 py-2.5 text-center me-2 mb-2"
                      :class="modalContent?.status === 'resolvido' ? 'bg-green-800 border-[#03543f] outline-none ring-4 ring-green-300' : 'bg-transparent'"
                      @click="updateStatusByRelato('resolvido')"
                    >
                      RESOLVIDO
                    </button>
                    <button
                      type="button"
                      id="status"
                      class="hover:bg-yellow-500 border-[#c27803] text-[#c27803] before:bg-[#c27803] focus:outline-none focus:ring-4 focus:ring-yellow-300 font-medium rounded text-sm px-5 py-2.5 text-center me-2 mb-2"
                      :class="modalContent?.status === 'controlado' ? 'bg-yellow-500 border-[#c27803] outline-none ring-4 ring-yellow-300' : 'bg-transparent'"
                      @click="updateStatusByRelato('controlado')"
                    >
                      CONTROLADO
                    </button>
                    <button
                      type="button"
                      id="status"
                      class="hover:bg-red-800 border-[#9b1c1c] text-[#9b1c1c] before:bg-[#9b1c1c] focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded text-sm px-5 py-2.5 text-center me-2 mb-2"
                      :class="modalContent?.status === 'cancelado' ? 'bg-red-800 border-[#9b1c1c] outline-none ring-4 ring-red-300' : 'bg-transparent'"
                      @click="updateStatusByRelato('cancelado')"
                    >
                      CANCELADO
                    </button>
                  </div>
                </div>
              </section>
            </main>
          </section>
        </div>
      </BaseModal>
    </Transition>
  </section>
</template>

<script setup>
import DataTable from './../../components/_partials/DataRelatosTable.vue'
import DropDownOptions from '@/components/Tables/DropDownOptions.vue'
import SearchInput from '@/components/Tables/SearchInput.vue'
import NoDataAnim from '@/components/Lotties/NoDataAnim.vue'
import BaseModal from '@/components/Modals/BaseModal.vue'
import RcdService from '../../service/rcd.service'
import moment from 'moment'
import { showToast as toast } from '@/helpers/UseToasts'
import { computed, onMounted, ref } from 'vue'
import { dataRcd } from '../../store'
import { initFlowbite } from 'flowbite'
import { storeApp } from '@/store'

import { PhFileArrowUp, PhX } from '@phosphor-icons/vue'

const dataTable = computed(() => store.getters?.getRelatos)

const iconSkull = require('@/assets/skull.webp')
const searchTerm = ref('')
const selectedFilter = ref('')
const classification = ref('')
const skulls = ref(0)
const store = dataRcd
const filters = [...new Set(dataTable?.value.map((i) => i.status))]

const isModalOpen = computed(() => store.getters.getDrawerModal)
const modalContent = computed(() => store.getters.getDrawerModalContent)

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable.value.filter((row) => {
    if (selectedFilter.value === 'Todos') selectedFilter.value = ''

    const matchesDropdown =
      !selectedFilter.value || row.status === selectedFilter.value

    const matchesSearch =
      !searchTerm.value ||
      ['id', 'name', 'relatoCompe', 'relatoClassi', 'status', 'relatoEmpresa'].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesDropdown && matchesSearch
  })
})

function formatDate (date) {
  return moment(date).format('D/MM/Y')
}

function closeModal () {
  store.dispatch('setModalDesactive')
}

function setClassification () {
  const frequency = modalContent.value.frequency
  const gravity = modalContent.value.gravity

  if (frequency === 'RARO' && gravity === 'BAIXA') {
    skulls.value = 0
    return (classification.value = 'Risco Trivial')
  }
  if (frequency === 'RARO' && gravity === 'MODERADA') {
    skulls.value = 0
    return (classification.value = 'Risco Baixo')
  }
  if (frequency === 'RARO' && gravity === 'ALTA') {
    skulls.value = 2
    return (classification.value = 'Risco Alto')
  }

  if (frequency === 'OCASIONAL' && gravity === 'BAIXA') {
    skulls.value = 0
    return (classification.value = 'Risco Baixo')
  }
  if (frequency === 'OCASIONAL' && gravity === 'MODERADA') {
    skulls.value = 1
    return (classification.value = 'Risco Moderado/Alto')
  }
  if (frequency === 'OCASIONAL' && gravity === 'ALTA') {
    skulls.value = 3
    return (classification.value = 'Risco Substancial')
  }

  if (frequency === 'FREQUENTE' && gravity === 'BAIXA') {
    skulls.value = 0
    return (classification.value = 'Risco Moderado')
  }
  if (frequency === 'FREQUENTE' && gravity === 'MODERADA') {
    skulls.value = 3
    return (classification.value = 'Risco Substancial')
  }
  if (frequency === 'FREQUENTE' && gravity === 'ALTA') {
    skulls.value = 4
    return (classification.value = 'Risco Crítico')
  }
}

async function deleteRelato (id) {
  storeApp.state.loading = true
  const confirm = window.confirm('Deseja realmente desativar este relato?')
  if (confirm) {
    await RcdService.removeRelato(id)
      .then((res) => {
        storeApp.state.loading = false

        if (res?.data?.success) {
          store.dispatch('setRelatos', res?.data?.relatos)

          return toast('Sucesso', res?.data?.message, 'success')
        }
      })
      .catch((err) => {
        storeApp.state.loading = false

        if (err?.response?.data?.error && err.response.data.status === 400) {
          return toast('Aviso', err.response.data.message, 'error')
        }

        return toast('Aviso', 'Algo deu errado ao remover relato', 'error')
      })
  }
  storeApp.state.loading = false
}

async function updateStatusByRelato (status) {
  storeApp.state.loading = true
  if (typeof modalContent.value === 'object') {
    modalContent.value.status = status
  }

  const $data = { status: status }

  await RcdService.updateRelato(modalContent?.value?.id, $data)
    .then(res => {
      if (res.data.success) {
        store.dispatch('setRelatos', res?.data?.relatos)

        return toast(
          'Sucesso',
          res.data?.message,
          'success'
        )
      }
    }).catch(err => {
      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao buscar unidades',
        'error'
      )
    })
  storeApp.state.loading = false
}

onMounted(() => {
  initFlowbite()
})
</script>

<style scoped lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

#status {
 padding: 0.8em 0.8em;
 position: relative;
 overflow: hidden;
 background-color: transparent;
 text-align: center;
 text-transform: uppercase;
 font-size: 16px;
 transition: .3s;
 z-index: 1;
 font-family: inherit;
}

#status::before {
  content: '';
  width: 0;
  height: 300%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  transition: .5s ease;
  display: block;
  z-index: -1;
}

#status:hover::before {
 width: 80%;
}

#status:hover {
 color: white;
 font-weight: bold;
}

.bord {
  box-shadow: rgba(0, 0, 0, 0.2) 40px 60px 70px -7px;
}

</style>
